import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, InputNumber, Select } from 'antd';
import { Amount } from '../CreateItinerary/CreateItineraryForm';
import { Vat } from '../../../graphql/datamodel.gen';
import { capitalizeFirstChar } from '../../../utils/string';
interface IProps extends FormComponentProps {
  onSubmit: (values: ICreateAmountFormValues) => any;
  amount?: Amount;
  vatTypes: Vat[];
}
interface IState {}

export interface ICreateAmountFormValues {
  concept?: string;
  amount: number;
  vat: number;
}

class CreateAmountForm extends React.Component<IProps, IState> {
  private DEFAULT_VAT: number = 0.21;

  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values: ICreateAmountFormValues) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  render(): React.ReactNode {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form
        id="create-amount-form"
        layout={'vertical'}
        onSubmit={this.handleSubmit}
      >
        <Form.Item label={'Concepto'}>
          {getFieldDecorator('concept', {
            initialValue: this.props.amount?.concept,
          })(<Input.TextArea autoSize={{ minRows: 5, maxRows: 10 }} />)}
        </Form.Item>
        <Form.Item>
          <div
            style={{
              display: 'flex',
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Form.Item
              label={'Importe'}
              required={true}
              style={{ width: '50%' }}
            >
              {getFieldDecorator('amount', {
                initialValue: this.props.amount?.amount || 0,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, introduce un importe',
                  },
                ],
              })(
                <InputNumber
                  style={{ width: '100%' }}
                  min={0}
                  size={'large'}
                  precision={2}
                  decimalSeparator={','}
                  autoComplete={'cc-csc'}
                />,
              )}
            </Form.Item>
            <Form.Item
              label={'I.V.A'}
              style={{ marginLeft: 10, width: '50%' }}
              required={true}
            >
              {getFieldDecorator('vat', {
                initialValue:
                  this.props.amount?.vat !== undefined
                    ? this.props.amount?.vat
                    : this.DEFAULT_VAT,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, selecciona el tipo de I.V.A',
                  },
                ],
              })(
                <Select size={'large'} style={{ width: '100%' }}>
                  {this.props.vatTypes.map((vat) => {
                    return (
                      <Select.Option value={vat.value}>
                        {capitalizeFirstChar(vat.translation)}
                      </Select.Option>
                    );
                  })}
                </Select>,
              )}
            </Form.Item>
          </div>
        </Form.Item>
      </Form>
    );
  }
}

const MyCreateAmountForm = Form.create<IProps>()(CreateAmountForm);

export default MyCreateAmountForm;
